import PropTypes from 'prop-types';

function MMBakeryActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_386_11316)">
                <path
                    d="M4.9738 15.8204C3.67547 12.5039 3.30687 11.8394 2.38502 9.61215C1.30426 7.00156 1.69512 2.62113 5.18679 1.49509C7.90973 0.620127 10.1931 1.81576 12.3376 5.65139C14.2425 9.04699 15.5468 12.7728 16.2573 14.4432C16.9678 16.1136 20.8652 22.5651 20.1153 26.1554C19.5856 28.7081 16.5411 30.9272 13.0524 29.1977C9.89871 27.6312 9.41731 25.7561 7.68227 22.0167C5.94723 18.2772 4.9738 15.8204 4.9738 15.8204Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.00788 14.1462C7.44705 13.1363 8.99844 9.43906 13.5617 10.7892C12.0627 12.5944 7.00788 14.1462 7.00788 14.1462Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.00569 18.9577C9.43994 17.9469 10.9913 14.2496 15.5546 15.5997C14.0566 17.4001 9.00569 18.9577 9.00569 18.9577Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.6675 25.8026C12.1008 24.7967 13.6532 21.0945 18.2155 22.4496C16.7224 24.2509 11.6675 25.8026 11.6675 25.8026Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.28447 9.42125C4.71776 8.41537 6.27012 4.71318 10.8324 6.06821C9.3393 7.86951 4.28447 9.42125 4.28447 9.42125Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.0351 20.3961C14.909 21.9402 17.2568 23.5474 18.2691 23.6853C18.923 23.7798 23.7485 24.0201 25.4502 24.2407C27.152 24.4613 27.7428 24.2643 27.8334 23.122C27.924 21.9796 28.3179 18.1665 28.3101 17.2684C28.3022 16.3702 28.7828 16.319 29.3106 15.996C30.2599 15.417 30.0197 13.3095 29.5115 12.5335C29.0034 11.7575 28.4204 10.9106 25.6039 10.4221C24.4221 10.2133 23.2404 10.0873 22.6692 10.0282C20.869 9.88638 16.7604 9.63428 16.7604 9.63428C16.5989 11.5487 15.1021 15.287 15.7363 15.8385C16.0238 16.0866 15.3817 17.4456 15.366 17.8553C15.3253 18.7098 15.2146 19.5596 15.0351 20.3961V20.3961Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M28.4794 16.559C28.4794 16.559 25.5133 16.3502 21.2353 16.2557C19.2382 16.2163 19.896 20.2972 20.0536 23.6416C20.353 23.7716 24.5285 24.1655 26.1002 24.3073C27.6719 24.4491 27.7428 24.0709 27.8807 22.6095C28.0186 21.1481 28.0304 19.2927 28.4794 16.559Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.2495 19.3519C11.1274 20.9 10.4262 22.9917 11.4346 23.1335C12.0885 23.228 16.5555 23.4683 18.2691 23.685C19.9826 23.9016 20.5617 23.7086 20.6523 22.5702C20.7429 21.4318 21.1368 17.6147 21.125 16.7127C21.1131 15.8106 21.5977 15.7673 22.1294 15.4443C23.0788 14.8652 22.8385 12.7578 22.3264 11.9778C21.8143 11.1978 21.2392 10.3588 18.4069 9.86641C16.8014 9.61044 15.1727 9.53118 13.5499 9.63006C11.7497 9.79157 10.312 10.8118 10.1938 12.226C10.0362 14.1365 10.4892 14.3531 11.1234 14.9007C11.2587 15.0489 11.3607 15.2244 11.4225 15.4153C11.4843 15.6062 11.5046 15.8082 11.4819 16.0076C11.4307 17.2405 11.2495 19.3519 11.2495 19.3519Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_386_11316">
                    <rect width="30" height="30" fill="white" transform="translate(0.894531 0.380859)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default MMBakeryActive;

MMBakeryActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

MMBakeryActive.defaultProps = {
    className: null,
};
